import React from "react";
import { Divider, Row, Col, Card } from "antd";
import moment from "moment";

import OrderRating from "./OrderRating";
import OrderResponseFiles from "./OrderResponseFiles";

class OrderCompleted extends React.Component {
  render() {
    const { order, orderId } = this.props;
    const { updatedAt } = order;
    return (
      <Row gutter={32}>
        <Row>
          <h2>Orden Completada</h2>
          <Divider />
        </Row>
        <Row gutter={16}>
          <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
            <Card
              title="Valoración del servicio"
              bordered
              style={{ boxShadow: "var(--shadow-super-light)" }}
            >
              <OrderRating order={order} orderId={orderId} />
            </Card>
          </Col>
          <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
            <Card
              title="Archivos de la orden"
              bordered
              style={{ boxShadow: "var(--shadow-super-light)" }}
            >
              <OrderResponseFiles order={order} orderId={orderId} />
            </Card>
          </Col>
          <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
            <Card
              title="Última actualización"
              bordered
              style={{ boxShadow: "var(--shadow-super-light)" }}
            >
              {moment(updatedAt).format("LLL")}
            </Card>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default OrderCompleted;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderCompleted.js